
$('.js-collection-carousel').slick({
  dots: true,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: "<a href='#' class='slick-prev'><i class='carousel-arrow-prev'></i></a>",
  nextArrow: "<a href='#' class='slick-next'><i class='carousel-arrow-next'></i></a>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        arrows:true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows:true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

 
// PDP CAROUSEL WITH THUMBS

// Enable on mobile devices only

/*
function pdpCarousel() {
  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    fade:true,
    autoplay: false,
    speed: 300,
    lazyLoad: 'ondemand',
    asNavFor: '.js-slider-thumbs'});
  // Thumbnail/alternates slider for product page
  $('.js-slider-thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });

$('.single-option-selector').change(function() {
   setTimeout(() => {
  var selectedIndex = $('[data-product-gallery-selected="true"]').data('product-gallery-figure');
  $('.js-slider-primary').slick('slickGoTo', selectedIndex);
  console.log(selectedIndex);
  }, 500);
});
             
//keeps thumbnails active when changing main image, via mouse/touch drag/swipe
  
//   $('.js-slider-primary').on('afterChange', function(event, slick, currentSlide, nextSlide){
//     //remove all active class
//     $('.js-slider-thumbs .slick-slide').removeClass('slick-current');
//     //set active class for current slide
//     $('.js-slider-thumbs .slick-slide:not(.slick-cloned)').eq(currentSlide).addClass('slick-current');  
//   });
 
}
*/

// Initiate slider on page load

/*
if($(window).width() < 1020) {
    pdpCarousel();
} else {
  $('.js-slider-primary').slick('unslick');
  $('.js-slider-thumbs').slick('unslick');
}

// Update slider on window resize
$(window).resize(function(e){
  if($(window).width() < 1020) {
      pdpCarousel();
  } else {
    $('.js-slider-primary').slick('unslick');
    $('.js-slider-thumbs').slick('unslick');
  }
});
*/

$(document).ready(function() {
  if (!$('.js-slider-primary').length) return;

  // Find the initially selected slide index (handles variant URL params where
  // the server-rendered Liquid may mark a non-zero slide as selected).
  var initialSlide = 0;
  $('.js-slider-primary [data-product-gallery-figure]').each(function(i) {
    if ($(this).attr('data-product-gallery-selected') === 'true') {
      initialSlide = i;
      return false; // break
    }
  });

  // ── Main product image slider ──────────────────────────────────────────────
  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    speed: 300,
    initialSlide: initialSlide,
    asNavFor: '.js-slider-thumbs'
  });

  // ── Thumbnail strip – linked to the primary slider ─────────────────────────
  $('.js-slider-thumbs').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    swipeToSlide: true,
    touchThreshold: 100,
    arrows: false,
    dots: false,
    centerMode: false,
    infinite: false,
    focusOnSelect: true,
    initialSlide: initialSlide,
    asNavFor: '.js-slider-primary',
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 4 } }
    ]
  });

  // ── Keep data-product-gallery-selected in sync for pacific.js ─────────────
  // Pacific.js uses this attribute to manage video/model/XR media state and
  // to highlight the active thumbnail via CSS.
  $('.js-slider-primary').on('afterChange', function(event, slick, currentSlide) {
    var $figures = $(this).find('[data-product-gallery-figure]');
    $figures.each(function(i) {
      $(this)
        .attr('data-product-gallery-selected', i === currentSlide ? 'true' : 'false')
        .attr('aria-hidden', i === currentSlide ? 'false' : 'true');
    });
    $('.js-slider-thumbs [data-product-gallery-thumbnail]').each(function(i) {
      $(this).attr('data-product-gallery-selected', i === currentSlide ? 'true' : 'false');
    });
  });

  // ── Variant switch: navigate primary slider to the correct image ───────────
  // Pacific.js fires 'shopify-variants:switch-variant' and also calls
  // productGallery.selectMediaByVariant(), which updates data attributes but
  // does not know about the Slick instance.  We bridge that here.
  $(window).on('shopify-variants:switch-variant', function(event, data) {
    if (!data.variant || !data.variant.featured_media) return;
    var mediaId = String(data.variant.featured_media.id);
    $('.js-slider-primary [data-product-gallery-figure]').each(function(i) {
      if (String($(this).data('media')) === mediaId) {
        $('.js-slider-primary').slick('slickGoTo', i, true); // instant, no animation
        return false; // break
      }
    });
  });

  $(window).on('resize orientationchange', function() {
    $('.js-slider-primary').slick('resize');
    $('.js-slider-thumbs').slick('resize');
  });
});


$(document).ready(function() {
  $('.cart-price .money').on('DOMSubtreeModified', function() {
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      const shippingCountdownSelector = document.querySelectorAll(".shipping-countdown p span");
      const cleanCartTotal = (data.items_subtotal_price) / 100;
      const shippingThreshold = parseInt(document.querySelector(".shipping-countdown .shipping-threshold").innerText);
      const emptyCart = document.querySelectorAll(".shipping-countdown .empty-cart");
      const progressCart = document.querySelectorAll(".shipping-countdown .progress-cart");
      const fullCart = document.querySelectorAll(".shipping-countdown .full-cart");
    
      if(cleanCartTotal > 0 && cleanCartTotal < shippingThreshold) {
        for (var i = 0; i < emptyCart.length; i++) {
          emptyCart[i].style.display = "none";
        }
        for (var i = 0; i < fullCart.length; i++) {
          fullCart[i].style.display = "none";
        }
        for (var i = 0; i < progressCart.length; i++) {
          progressCart[i].style.display = "block";
        }
        for (var i = 0; i < shippingCountdownSelector.length; i++) {
          shippingCountdownSelector[i].innerHTML = '$' + parseFloat(shippingThreshold - cleanCartTotal).toFixed(2);
        }
      } else if(cleanCartTotal >= shippingThreshold) {
        for (var i = 0; i < emptyCart.length; i++) {
          emptyCart[i].style.display = "none";
        }
        for (var i = 0; i < progressCart.length; i++) {
          progressCart[i].style.display = "none";
        }
        for (var i = 0; i < fullCart.length; i++) {
          fullCart[i].style.display = "block";
        }
      } else if(cleanCartTotal == 0) {
        for (var i = 0; i < fullCart.length; i++) {
          fullCart[i].style.display = "none";
        }
        for (var i = 0; i < progressCart.length; i++) {
          progressCart[i].style.display = "none";
        }
        for (var i = 0; i < emptyCart.length; i++) {
          emptyCart[i].style.display = "block";
        }
      }
      return data
    });
  });
});

// Collection Grid Toggle
document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'collection_grid_compact';
  const COMPACT_CLASS = 'collection-compact-layout';

  const productsEl = document.querySelector('.collection-products');
  const toggleBtns = document.querySelectorAll('[data-grid-toggle]');

  if (!productsEl || !toggleBtns.length) return;

  function setLayout(compact) {
    productsEl.classList.toggle(COMPACT_CLASS, compact);

    toggleBtns.forEach(function (btn) {
      const isMatch = compact
        ? btn.dataset.gridToggle === 'compact'
        : btn.dataset.gridToggle === 'default';
      btn.classList.toggle('is-active', isMatch);
      btn.setAttribute('aria-pressed', String(isMatch));
    });

    try {
      localStorage.setItem(STORAGE_KEY, compact ? '1' : '0');
    } catch (e) {}
  }

  // Restore preference on page load
  try {
    if (localStorage.getItem(STORAGE_KEY) === '1') {
      setLayout(true);
    }
  } catch (e) {}

  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setLayout(btn.dataset.gridToggle === 'compact');
    });
  });
});